import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { AtendimentoForms } from "../../components/Callback/atendimento-forms";
import { ChatButton } from "../../components/Callback/chat-button";
import { FilaAtendimento } from "../../components/Callback/fila-atendimento";
import { Chat } from "../../components/Callback/chat";
import { useAuth } from "../../context/AuthContext";
import { useChatWhatsApp } from "../../context/ChatWhatsAppContext";
import { useFila } from "../../context/FilaContext";
import { useDividas } from "../../context/DividasContext";
// import { DiscadorProvider } from "../../components/Discador";
import { OperadoraProvider } from '../../hooks/OperadoraProvider'
import { GenericModal } from "../../components/Modal";
import { useModal } from "../../hooks/ModalContext";
import { SelectOperadora } from "../../components/generics/select-operadora";

interface UsuarioDiscador {
  urlDiscador: string;
  usuarioDiscador: string;
  senhaDiscador: string;
  token3C: string;
}

export function Atendimento() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [operadora, setOperadora] = useState('3C')
  const { validToken, cookies, decodedToken } = useAuth()
  const [, setCookies] = useCookies(['token', 'user', 'whatsapp'])
  const { loginChat } = useChatWhatsApp()
  const { clearSelectedFila } = useFila()
  const { clearDividas } = useDividas()
  const { modalInfo, onClose } = useModal();

  useEffect(() => {
    clearDividas()
    clearSelectedFila()
  }, [])

  useEffect(() => {
    validToken(cookies?.token)
    if (!cookies?.user) {
      const decoded = decodedToken()
      setCookies('user', {
        id_operador: decoded.id_usuario,
        nome: decoded.nome,
      })
    }
  }, [])

  useEffect(() => {
    if (!cookies?.whatsapp) {
      loginChat({ login: '965.773.472-04', password: '123456789' }).then((res) => {
        setCookies('whatsapp', {
          token: res.token, queueId: res.queueId
        })
      })
    }
  }, [])

  const [usuarioDiscador, setUsuarioDiscador] = useState<UsuarioDiscador | null>(null);

  useEffect(() => {
    const decoded = decodedToken();

    if (decoded.urlDiscador) {
      // console.log(decoded.urlDiscador)
      setUsuarioDiscador({
        urlDiscador: decoded.urlDiscador,
        usuarioDiscador: decoded.usuarioDiscador,
        senhaDiscador: decoded.senhaDiscador,
        token3C: decoded.token3C
      });
    }
  }, [decodedToken]);

  return (
    <>
      <OperadoraProvider
        socketUrl={usuarioDiscador?.urlDiscador || ''}
        user={usuarioDiscador?.usuarioDiscador || ''}
        password={usuarioDiscador?.senhaDiscador || ''}
        token3C={usuarioDiscador?.token3C || ''}
        operadora={operadora}      >


        <section>
          <div className="m-4 mt-10 flex max-h-max  flex-grow flex-col overflow-y-auto">
            <div className="flex gap-4">
              <button className="aba bg-slate-200">Callback</button>
              <SelectOperadora operadora={operadora} setOperadora={setOperadora} />


            </div>
            <div className="mb-2 flex h-[85vh] w-[81%] items-center justify-center gap-2 rounded-lg bg-slate-200 px-2 py-2 border-2">
              <FilaAtendimento />
              <AtendimentoForms />
            </div>

            {!isChatOpen && <ChatButton onClick={() => setIsChatOpen(true)} />}
            <div className="relative">
              <Chat isOpen={isChatOpen} closeSidebar={setIsChatOpen} operadora={operadora} />
            </div>
          </div>

          <GenericModal
            title={modalInfo.title}
            type={modalInfo.type}
            onClose={() => onClose()}
            show={(modalInfo.isOpen && modalInfo.title === 'Qualificacao Chamada') || (modalInfo.isOpen && modalInfo.title === 'Campanha Discador')}
            modalType="Qualificacao Chamada"
          />
        </section>
      </OperadoraProvider>
    </>
  );
}
